import SolutionTemplate from '@LandingFunctionalDisplay/SolutionTemplate';
import { smbData } from '@LandingFunctionalDisplay/SolutionTemplate/solutionData';

export default function SMBPage() {
    return <SolutionTemplate {...smbData} />;
}
